import React from 'react';
import { ElementConfigType } from '../store/PageEditorStore';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';

type Props = ElementConfigType;

export const ImgComponent: MyComponentType<Props> = (props: Props) => {
  const { styles, privateSchema, parentNodeIsBody } = props;

  return (
    <div
      style={Object.assign(
        parentNodeIsBody
          ? {
              width: '100%',
              display: 'block',
              paddingTop: 16,
              // eslint-disable-next-line radix
              paddingBottom: `${parseInt(`${styles?.width}`) / privateSchema?.src?.[0]?.aspectRatio}%`,
              height: privateSchema?.src?.[0]?.aspectRatio ? 0 : 'auto',
              marginBottom: 16,
            }
          : {
              width: '100%',
              display: 'block',
              // eslint-disable-next-line radix
              paddingBottom: `${parseInt(`${styles?.width}`) / privateSchema?.src?.[0]?.aspectRatio}%`,
              height: privateSchema?.src?.[0]?.aspectRatio ? 0 : 'auto',
            },
        styles,
      )}
    >
      <img
        style={{ width: '100%', borderRadius: '5px' }}
        src={`${
          // eslint-disable-next-line max-len
          privateSchema?.src?.[0]?.mediaSrc ||
          props.config.src ||
          'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800'
        }?image_process=resize,w_1200/quality,Q_80/format,webp`}
        alt={privateSchema?.src?.[0]?.alt}
      />
    </div>
  );
};

ImgComponent.definition = {
  // id: 'img-component',
  id: ComponentIdEnum.IMG_COMPONENT,
  name: '图片组件_1',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_200',
  position: 8, // 显示顺序
  config: {
    text: '这是一个图片容器',
    src: 'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800',
  },
  styles: {
    width: '100%',
  },
  privateSchema: {},
};
